import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import loader from '../../assets/images/loader.gif'

const Image = styled.img.attrs(props=> ({
  alt:  props.alt,
  src: props.src,
  style: props.style
}))`
  position: absolute;
  left: 0;
  right: 0;
  top: 25%;
  margin: auto;
`

const InlineLoader = ({ style }) => {
  return <Image src={loader} style={style} alt="" />
}

InlineLoader.propTypes = {
  style: PropTypes.object
}

export default InlineLoader



// WEBPACK FOOTER //
// ./src/components/InlineLoader/InlineLoader.js